"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnCallEnd = void 0;
const react_1 = require("react");
/**
 * Will invoke the onEnd function, if defined, when the component is unmounted.
 * @param roomId The RoomId for the active room
 * @param onEnd A function to invoke with the RoomId
 */
function useOnCallEnd(roomId, onEnd) {
    return (0, react_1.useEffect)(() => {
        return () => {
            if (onEnd) {
                onEnd(roomId);
            }
        };
    }, [onEnd, roomId]);
}
exports.useOnCallEnd = useOnCallEnd;
//# sourceMappingURL=use_on_call_end.js.map